import React, { useState, useEffect, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import "./Navbar.css";
import logo from "../../assets/logo.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cartItems } = useContext(CartContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  // 🔥 ULTRA FORCE SCROLL RESET
  const forceScrollToTop = () => {
    // Scroll window
    window.scrollTo(0, 0);

    // Scroll document element
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }

    // Scroll body
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // Scroll ANY scrollable container
    const allElements = document.querySelectorAll("*");

    allElements.forEach((el) => {
      if (el.scrollHeight > el.clientHeight) {
        el.scrollTop = 0;
      }
    });

    setMenuOpen(false);
  };

  const handleCartClick = () => {
    forceScrollToTop();
    navigate("/cart");
  };

const handleActionClick = () => {
  forceScrollToTop();
  navigate("/products");
};

  return (
    <>
      <nav className="navbar">

        {/* LEFT */}
        <div className="navbar-left">
          <NavLink to="/" end onClick={forceScrollToTop}>
            <img src={logo} alt="Logo" />
          </NavLink>
        </div>

        {/* CENTER */}
        <ul className="navbar-center">
          <li>
            <NavLink to="/" end onClick={forceScrollToTop}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/products" onClick={forceScrollToTop}>
              Products
            </NavLink>
          </li>
          <li>
            <NavLink to="/CeramicComponents" onClick={forceScrollToTop}>
              Ceramics
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={forceScrollToTop}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={forceScrollToTop}>
              Contact
            </NavLink>
          </li>
        </ul>

        {/* RIGHT */}
        <div className="navbar-right">

          {/* CART ICON */}
          <div
            className="cart-icon"
            onClick={handleCartClick}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
            >
              <path d="M7 4h-2l-1 2h2l3.6 7.59-1.35 2.44c-.16.29-.25.62-.25.97 
              0 1.1.9 2 2 2h10v-2h-10l1.1-2h7.45c.75 
              0 1.41-.41 1.75-1.03l3.58-6.49a1 
              1 0 0 0-.87-1.48h-14.76l-.94-2zm0 
              13a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 
              0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
            </svg>

            {cartItems.length > 0 && (
              <span className="cart-count">
                {cartItems.reduce((total, item) => total + item.quantity, 0)}
              </span>
            )}
          </div>

          <button
            className="action-btn"
            onClick={handleActionClick}
          >
            View Products
          </button>

        </div>

        {/* HAMBURGER */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </nav>

      {/* MOBILE PANEL */}
      <div className={`mobile-panel ${menuOpen ? "active" : ""}`}>
        <div
          className="mobile-close"
          onClick={() => setMenuOpen(false)}
        >
          ✕
        </div>

        <ul>
          <li>
            <NavLink to="/" end onClick={forceScrollToTop}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/products" onClick={forceScrollToTop}>
              Products
            </NavLink>
          </li>
          <li>
            <NavLink to="/CeramicComponents" onClick={forceScrollToTop}>
              Ceramics
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={forceScrollToTop}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={forceScrollToTop}>
              Contact
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}